import { IDropdown } from '@/constants/default'
import { useEffect, useState } from 'react'

type DropdownCheckboxProps = {
  selected: IDropdown[]
  onFilter: (selected: IDropdown[]) => void
  data: IDropdown[]
  label?: string
}

export default function DropdownCheckbox(props: DropdownCheckboxProps) {
  const { onFilter, data, label = "Status" } = props
  const [isOpen, setIsOpen] = useState(false)
  const [selected, setSelected] = useState<IDropdown[]>(props.selected)
  
  const toggleSelection = (status: IDropdown) => {
    setSelected((prev) =>
      prev.findIndex(item => item.value === status.value) !== -1
        ? prev.filter((s) => s.value !== status.value)
        : [...prev, status]
    );
  };

  const onApplyFilter = () => {
    onFilter(selected)
    setIsOpen(false)
  }

  const onClearFilter = () => {
    setSelected([])
    onFilter([])
    setIsOpen(false)
  }

  useEffect(() => {
    setSelected(props.selected)
  }, [props.selected])
  
  return (
    <div className="relative w-64">
      <div
        className="inline-flex items-center space-x-2 border border-gray-300 rounded-full text-gray-700 text-sm cursor-pointer"
      >
        <div className='ps-2 py-1.5'>
          {selected.length > 0 ? <i className="fa-sharp fa-solid fa-circle-xmark dark:text-white" onClick={onClearFilter} /> : <i className="fa-solid fa-circle-plus dark:text-white" />}
        </div>
        <div className='inline-flex items-center pe-1.5 py-1.5' onClick={() => setIsOpen(!isOpen)}>
          <span className="font-medium dark:text-white">{label}</span>
          {
            selected.length > 0 &&  <span className="text-primary font-medium ms-2">
              {selected.length > 1 ? `${selected.length} selected` : selected[0]?.label}
            </span>
          }
          <svg className="w-4 h-4 text-gray-500 ms-1 dark:text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </div>
      </div>
      {isOpen && (
        <div className="absolute mt-2 w-64 bg-white shadow-lg rounded-lg p-4 dark:bg-form-input">
          <p className="text-gray-700 font-medium mb-2 dark:text-white">Filter by Status</p>
          <div className="space-y-2">
            {data.map((status: IDropdown) => (
              <label key={status.value} className="flex items-center space-x-2">
                <input
                  type='checkbox'
                  checked={selected.findIndex((i: IDropdown) => i.value === status.value) !== -1}
                  onChange={() => toggleSelection(status)}
                />
                <span>{status.label}</span>
              </label>
            ))}
          </div>
          <button type='button' className="w-full rounded bg-primary mt-3 py-1.5 px-2 font-medium text-white text" onClick={onApplyFilter}>Apply</button>
        </div>
      )}
    </div>
  );
};
